(function($){
    if (!$(".js-footer__lang-switcher").length) return;

    $(".js-footer__lang-switcher").click(function() {
        $(this).closest(".js-footer__locales").toggleClass("is-open");
    });

})(jQuery);


// WEBPACK FOOTER //
// ./common.blocks/footer/footer.js